<template>
  <div>
    <div class="hidden pc:block bg-wrapper">
      <div class="flex items-center justify-center bg py-[76px] max-w-[1920px] mx-auto">
        <p class="text-[40px] font-bold text-neutral-950">자기주도학습</p>
      </div>
    </div>

    <section class="py-14 pc:py-[140px] pc-con-wrapper1">
      <p class="mb-5 text-lg font-bold pc:text-2xl pc:mb-4">※ 확인해주세요!</p>

      <ul class="p-5 border border-solid border-[#E7E7E7] rounded-md text-sm text-[#737373] mb-14 pc:p-6 pc:text-lg pc:mb-[70px]">
        <!-- 부산 -->
        <template v-if="idxLeSiteMain === 52">
          <li class="flex items-baseline gap-2">
            <p class="w-2 pc:w-2.5">1.</p>
            <p>자기주도학습은 학습자의 수업이 배정된 이후 확인 가능합니다.</p>
          </li>
          <li class="flex items-baseline gap-2">
            <p class="w-2 pc:w-2.5">2.</p>
            <p>수업 안내문 수신 이후, 해당 페이지를 확인해주세요.</p>
          </li>
          <li class="flex items-baseline gap-2">
            <p class="w-2 pc:w-2.5">3.</p>
            <p>개인 스케줄에 따라 자기주도학습 스케줄에 변경이 있을 수있습니다.</p>
          </li>
          <li class="flex items-baseline gap-2">
            <p class="w-2 pc:w-2.5">4.</p>
            <p>자기주도학습은 수업기간 종료 이후 모두 삭제 됩니다.</p>
          </li>
        </template>
        <!-- 그외 지역 -->
        <template v-else>
          <li class="flex items-baseline gap-2">
            <p class="w-2 pc:w-2.5">1.</p>
            <p>자기주도학습은 학습자의 수업이 배정된 이후 확인 가능합니다.</p>
          </li>
          <li class="flex items-baseline gap-2">
            <p class="w-2 pc:w-2.5">2.</p>
            <p>수업 안내문 수신 이후, 해당 페이지를 확인해주세요.</p>
          </li>
        </template>
      </ul>

      <!-- 교재 선택 -->
      <div v-if="idxLeSiteMain !== 52" class="mb-8 pc:mb-10">
        <label for="bookSelect" class="block mb-3 text-base font-bold pc:text-lg">교재 선택</label>
        <select
          id="bookSelect"
          v-model="currentBook"
          @change="handleBookChange"
          class="w-full px-4 py-3 border border-solid border-[#E7E7E7] rounded-md text-sm pc:text-base focus:outline-none focus:border-[#F97316]"
        >
          <option value="">교재를 선택해주세요</option>
          <option v-for="book in bookList" :key="book.idxBook" :value="book.idxBook">
            {{ book.bookName }}
          </option>
        </select>
      </div>

      <!-- 모바일 -->
      <div v-if="learningList.length === 0" class="py-20 text-center pc:hidden">
        <p class="text-base text-[#737373]">자기주도 학습이 진행되지 않는 과정입니다.</p>
      </div>
      <div v-else class="border-y border-solid border-[#0A0A0A] overflow-hidden pc:hidden">
        <table>
          <!-- dateType이 더 적으면 에러 발생하기 때문에 방어로직 처리 -->
          <tr
            v-for="(learningInfo, index) in learningList.slice(0, dateTypeA.length)"
            :key="learningInfo.round"
            class="border-b border-solid border-[#E5E5E5]"
          >
            <td
              :class="{
                'bg-[#FAFAFA]': learningInfo.isSubmit === 'Y',
                'bg-[#FFF7ED]': selectedRound === learningInfo.round,
                'bg-white': learningInfo.isSubmit === 'N' && selectedRound !== learningInfo.round,
              }"
              class="px-5 py-4"
              @click="learningInfo.bookName !== '-' ? getCheckTriedQuestion(learningInfo.round) : () => {}"
            >
              <div class="flex items-center justify-between gap-5 cursor-pointer">
                <div class="flex items-center gap-5">
                  <div class="flex justify-center items-center size-9 bg-white border border-solid border-[#707070] rounded-md">
                    <p class="text-sm text-[#737373] font-medium">
                      {{ learningInfo.isSubmit }}
                    </p>
                  </div>
                  <div class="space-y-1.5">
                    <p class="text-sm text-[#160F0D] text-left font-bold">{{ learningInfo.round }}회차</p>
                    <p class="text-sm text-[#737373] text-left font-medium">
                      제출기한 : {{ learnType === "A" ? dateTypeA[index].endDate : dateTypeB[index].endDate }}
                    </p>
                  </div>
                </div>
                <div class="w-2">
                  <img v-if="learningInfo.bookName !== '-'" src="@/assets/images/selfLearning/arrow.png" alt="icon" />
                  <div v-else>-</div>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>

      <!-- pc -->
      <div v-if="learningList.length === 0" class="hidden pc:block py-32 text-center">
        <p class="text-lg text-[#737373]">자기주도 학습이 진행되지 않는 과정입니다.</p>
      </div>
      <div v-else class="hidden pc:block border-y border-solid border-[#0A0A0A]">
        <table>
          <thead>
            <tr>
              <td
                class="w-[100px] py-6 border-r border-b border-solid border-[#E5E5E5] text-lg text-[#160F0D] text-center font-bold"
              >
                회차
              </td>
              <td
                v-if="idxLeSiteMain === 52"
                class="w-[230px] py-6 border-r border-b border-solid border-[#E5E5E5] text-lg text-[#160F0D] text-center font-bold"
              >
                수업일자/요일
              </td>
              <td
                v-if="idxLeSiteMain === 52"
                class="w-[230px] py-6 border-r border-b border-solid border-[#E5E5E5] text-lg text-[#160F0D] text-center font-bold"
              >
                자기주도학습 제출 기한
              </td>
              <td class="py-6 border-r border-b border-solid border-[#E5E5E5] text-lg text-[#160F0D] text-center font-bold">
                수업교재
              </td>
              <td
                class="w-[140px] py-6 border-r border-b border-solid border-[#E5E5E5] text-lg text-[#160F0D] text-center font-bold"
              >
                문제풀기/보기
              </td>
              <td class="w-[100px] py-6 border-b border-solid border-[#E5E5E5] text-lg text-[#160F0D] text-center font-bold">
                제출여부
              </td>
            </tr>
          </thead>
          <tbody>
            <!-- dateType이 더 적으면 에러 발생하기 때문에 방어로직 처리 -->
            <tr
              v-for="(learningInfo, index) in learningList.slice(0, dateTypeA.length)"
              :key="learningInfo.round"
              :class="{
                'bg-[#FAFAFA]': learningInfo.isSubmit === 'Y',
                'bg-[#FFF7ED]': selectedRound === learningInfo.round,
                'bg-white': learningInfo.isSubmit === 'N' && selectedRound !== learningInfo.round,
              }"
            >
              <td class="w-[100px] py-6 border-r border-b border-solid border-[#E5E5E5] text-lg text-[#737373] text-center">
                {{ learningInfo.round }}회
              </td>
              <td
                v-if="idxLeSiteMain === 52"
                class="py-6 border-r border-b border-solid border-[#E5E5E5] text-lg text-[#160F0D] text-center"
              >
                {{ learnType === "A" ? dateTypeA[index].startDate : dateTypeB[index].startDate }}
              </td>
              <td
                v-if="idxLeSiteMain === 52"
                class="py-6 border-r border-b border-solid border-[#E5E5E5] text-lg text-[#160F0D] text-center"
              >
                {{ learnType === "A" ? dateTypeA[index].endDate : dateTypeB[index].endDate }}
              </td>
              <td class="py-6 border-r border-b border-solid border-[#E5E5E5] text-lg text-[#160F0D] text-center">
                <p class="line-clamp-1">
                  {{ learningInfo.bookName }}
                </p>
              </td>
              <td class="w-[140px] py-6 border-r border-b border-solid border-[#E5E5E5] text-lg text-[#737373] text-center">
                <p
                  @click="learningInfo.bookName !== '-' ? getCheckTriedQuestion(learningInfo.round) : () => {}"
                  :class="{
                    underline: learningInfo.bookName !== '-',
                    'text-[#F97316]': selectedRound === learningInfo.round,
                  }"
                  class="cursor-pointer"
                >
                  {{ learningInfo.bookName === "-" ? "-" : "View" }}
                </p>
              </td>
              <td class="w-[100px] py-6 border-b border-solid border-[#E5E5E5] text-lg text-[#737373] text-center">
                {{ learningInfo.isSubmit }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 문제 화면 -->
    </section>
  </div>
</template>
<script setup>
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import axios from "@/plugins/axios.js";

const router = useRouter();
const store = useStore();
const idxLeSiteMain = Number(store.state.idxLeSiteMain);
const isQuestion = store.state.isQuestion;

// 부산 자기주도학습 날짜: 월목 으로 구분된 학습자
const dateTypeA = [
  { startDate: "2025-09-22 (Mon)", endDate: "2025-09-25 (Thu)" },
  { startDate: "2025-09-25 (Thu)", endDate: "2025-09-29 (Mon)" },
  { startDate: "2025-09-29 (Mon)", endDate: "2025-10-02 (Thu)" },
  { startDate: "2025-10-02 (Thu)", endDate: "2025-10-13 (Mon)" },
  { startDate: "2025-10-13 (Mon)", endDate: "2025-10-16 (Thu)" },
  { startDate: "2025-10-16 (Thu)", endDate: "2025-10-20 (Mon)" },
  { startDate: "2025-10-20 (Mon)", endDate: "2025-10-23 (Thu)" },
  { startDate: "2025-10-23 (Thu)", endDate: "2025-10-27 (Mon)" },
  { startDate: "2025-10-27 (Mon)", endDate: "2025-10-30 (Thu)" },
  { startDate: "2025-10-30 (Thu)", endDate: "2025-11-03 (Mon)" },
  { startDate: "2025-11-03 (Mon)", endDate: "2025-11-06 (Thu)" },
  { startDate: "2025-11-06 (Thu)", endDate: "2025-11-10 (Mon)" },
  { startDate: "2025-11-10 (Mon)", endDate: "2025-11-13 (Thu)" },
  { startDate: "2025-11-13 (Thu)", endDate: "2025-11-17 (Mon)" },
  { startDate: "2025-11-17 (Mon)", endDate: "2025-11-20 (Thu)" },
  { startDate: "2025-11-20 (Thu)", endDate: "2025-11-24 (Mon)" },
  { startDate: "2025-11-24 (Mon)", endDate: "2025-11-27 (Thu)" },
  { startDate: "2025-11-27 (Thu)", endDate: "2025-12-01 (Mon)" },
  { startDate: "2025-12-01 (Mon)", endDate: "2025-12-04 (Thu)" },
  { startDate: "2025-12-04 (Thu)", endDate: "2025-12-12 (Fri)" },
];

// 부산 자기주도학습 날짜: 화금 으로 구분된 학습자
const dateTypeB = [
  { startDate: "2025-09-23 (Tue)", endDate: "2025-09-26 (Fri)" },
  { startDate: "2025-09-26 (Fri)", endDate: "2025-09-30 (Tue)" },
  { startDate: "2025-09-30 (Tue)", endDate: "2025-10-10 (Fri)" },
  { startDate: "2025-10-10 (Fri)", endDate: "2025-10-14 (Tue)" },
  { startDate: "2025-10-14 (Tue)", endDate: "2025-10-17 (Fri)" },
  { startDate: "2025-10-17 (Fri)", endDate: "2025-10-21 (Tue)" },
  { startDate: "2025-10-21 (Tue)", endDate: "2025-10-24 (Fri)" },
  { startDate: "2025-10-24 (Fri)", endDate: "2025-10-28 (Tue)" },
  { startDate: "2025-10-28 (Tue)", endDate: "2025-10-31 (Fri)" },
  { startDate: "2025-10-31 (Fri)", endDate: "2025-11-04 (Tue)" },
  { startDate: "2025-11-04 (Tue)", endDate: "2025-11-07 (Fri)" },
  { startDate: "2025-11-07 (Fri)", endDate: "2025-11-11 (Tue)" },
  { startDate: "2025-11-11 (Tue)", endDate: "2025-11-14 (Fri)" },
  { startDate: "2025-11-14 (Fri)", endDate: "2025-11-18 (Tue)" },
  { startDate: "2025-11-18 (Tue)", endDate: "2025-11-21 (Fri)" },
  { startDate: "2025-11-21 (Fri)", endDate: "2025-11-25 (Tue)" },
  { startDate: "2025-11-25 (Tue)", endDate: "2025-11-28 (Fri)" },
  { startDate: "2025-11-28 (Fri)", endDate: "2025-12-02 (Tue)" },
  { startDate: "2025-12-02 (Tue)", endDate: "2025-12-05 (Fri)" },
  { startDate: "2025-12-05 (Fri)", endDate: "2025-12-12 (Fri)" },
];

const bookList = ref([]);
const currentBook = ref("");
const learningList = ref([]);
const learnType = ref("");
const userInfo = ref({});
const selectedRound = ref(-1);

const getBookList = async () => {
  try {
    const result = await axios.get("/user/question/book");
    const { success, message, data } = result.data;

    if (!success) {
      alert(message);
      return;
    }

    bookList.value = data;
  } catch (error) {
    console.error(error);
  }
};

const getLearningList = async (idxBook) => {
  if (!idxBook) {
    return;
  }

  try {
    const result = await axios.get(`/user/question/${idxBook}`);
    const { success, message, data } = result.data;

    if (!success) {
      console.error(message);
      learningList.value = [];
      learnType.value = "";
      return;
    }

    learningList.value = data.userQuestionList || [];
    learnType.value = data.userType;
  } catch (error) {
    console.error(error);
    learningList.value = [];
    learnType.value = "";
  }
};

const getCheckTriedQuestion = async (round) => {
  selectedRound.value = round;
  const result = await axios.get(`/user/question/${currentBook.value}/check/${round}`);
  const { success, message, data } = result.data;

  if (!success) {
    alert(message);
    return;
  }
  setTimeout(() => {
    window.open(
      `${window.location.origin}/questionPage?idxLeSiteMain=${idxLeSiteMain}&round=${round}&check=${data}&userName=${userInfo.value.kname}&idxBook=${currentBook.value}`,
      "_blank",
      "width=800, height=896, resizable=no, menubar=no, toolbar=no, location=no, status=no"
    );
  });
};

const getUserInfo = async () => {
  const result = await axios.get("/user/sugang/member");
  const { success, message, data } = result.data;

  if (!success) {
    alert(message);
    return;
  }
  userInfo.value = data;
};

const handleBookChange = () => {
  if (currentBook.value) {
    getLearningList(currentBook.value);
  }
};

onMounted(async () => {
  if (Number(idxLeSiteMain) === 52 || isQuestion === "Y") {
    await getBookList();

    // 첫 번째 교재를 기본으로 선택
    if (bookList.value.length > 0) {
      currentBook.value = bookList.value[0].idxBook;
      await getLearningList(currentBook.value);
    }

    await getUserInfo();
  } else {
    alert("자기주도학습 서비스 지역만 가능합니다");
    router.go(-1);
  }
});
</script>
<style lang="scss" scoped></style>
